/* ==========================================================================
   Banyo Yedek Parça — global tema scripti
   Framework yok, build yok. Tek global: window.Theme.
   Stateful UI parçaları Custom Element olarak tanımlanır.
   ========================================================================== */
(function () {
  'use strict';

  /* ----- Çekirdek yardımcılar ----- */
  const Theme = window.Theme || {};

  Theme.routes = window.routes || {};

  Theme.debounce = function (fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  Theme.fetchConfig = function (type = 'json') {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${type}`,
      },
    };
  };

  // Basit pub/sub
  const subscribers = {};
  Theme.on = function (event, cb) {
    (subscribers[event] = subscribers[event] || []).push(cb);
    return () => {
      subscribers[event] = (subscribers[event] || []).filter((c) => c !== cb);
    };
  };
  Theme.emit = function (event, payload) {
    (subscribers[event] || []).forEach((cb) => cb(payload));
  };

  // Odak tuzağı (drawer/menü için)
  Theme.trapFocus = function (container, elementToFocus = container) {
    // Idempotent: önceki handler varsa kaldır (çift açılışta listener sızıntısını önler)
    if (container.__trapHandler) {
      document.removeEventListener('keydown', container.__trapHandler);
      container.__trapHandler = null;
    }
    const focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last && last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first && first.focus();
      }
    }
    container.__trapHandler = handler;
    document.addEventListener('keydown', handler);
    (elementToFocus || container).focus();
  };
  Theme.removeTrapFocus = function (container, elementToFocus) {
    if (container && container.__trapHandler) {
      document.removeEventListener('keydown', container.__trapHandler);
      container.__trapHandler = null;
    }
    if (elementToFocus) elementToFocus.focus();
  };

  /* ----- Duyuru çubuğu kapatma (localStorage) ----- */
  function initAnnouncementDismiss() {
    document.querySelectorAll('[data-announcement-dismiss]').forEach((btn) => {
      const bar = btn.closest('[data-announcement]');
      if (!bar) return;
      const key = 'announcement-dismissed-' + (bar.dataset.announcement || 'default');
      if (localStorage.getItem(key) === '1') {
        bar.hidden = true;
        return;
      }
      btn.addEventListener('click', () => {
        bar.hidden = true;
        try { localStorage.setItem(key, '1'); } catch (e) {}
      });
    });
  }

  /* ----- Genel drawer/menü toggle ----- */
  // <button data-drawer-toggle="DRAWER_ID"> ... <div id="DRAWER_ID" data-drawer>
  function initDrawers() {
    document.querySelectorAll('[data-drawer-toggle]').forEach((toggle) => {
      const id = toggle.getAttribute('data-drawer-toggle');
      const drawer = document.getElementById(id);
      if (!drawer) return;

      const open = () => setDrawer(drawer, toggle, true);
      const close = () => setDrawer(drawer, toggle, false);

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = drawer.classList.contains('is-open');
        isOpen ? close() : open();
      });

      drawer.querySelectorAll('[data-drawer-close]').forEach((c) =>
        c.addEventListener('click', close)
      );
      drawer.addEventListener('click', (e) => {
        if (e.target === drawer || e.target.hasAttribute('data-drawer-overlay')) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    });
  }

  function setDrawer(drawer, toggle, open) {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('overflow-hidden', open);
    if (open) {
      Theme.trapFocus(drawer);
    } else {
      Theme.removeTrapFocus(drawer, toggle);
    }
    Theme.emit('drawer:toggle', { drawer, open });
  }

  /* ----- AJAX Sepet denetleyicisi (Blok 2'de genişletilir) ----- */
  Theme.cart = {
    async add(items, sections) {
      const body = { items: Array.isArray(items) ? items : [items] };
      if (sections) body.sections = sections;
      const res = await fetch(`${Theme.routes.cart_add_url || '/cart/add'}.js`, {
        ...Theme.fetchConfig(),
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) throw data;
      Theme.emit('cart:updated', data);
      return data;
    },
    async get() {
      const res = await fetch(`${Theme.routes.cart_url || '/cart'}.js`);
      return res.json();
    },
    async change(payload, sections) {
      const body = { ...payload };
      if (sections) body.sections = sections;
      const res = await fetch(`${Theme.routes.cart_change_url || '/cart/change'}.js`, {
        ...Theme.fetchConfig(),
        body: JSON.stringify(body),
      });
      const data = await res.json();
      Theme.emit('cart:updated', data);
      return data;
    },
  };

  // Para birimi formatı (cart.js fiyatları kuruş cinsinden)
  Theme.money = function (cents) {
    const num = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: window.shopCurrency || 'TRY' }).format(num);
    } catch (e) {
      return num.toFixed(2);
    }
  };

  // Tek sepet satırı HTML'i — cart-drawer.liquid'deki sunucu-render markup ile BİREBİR aynı.
  // (key tabanlı; adet/kaldır işlemlerinde data-line-key id olarak kullanılır)
  Theme.cartLineHTML = function (item) {
    const media =
      '<a href="' + item.url + '" class="cart-line__media">' +
      (item.image ? '<img class="cart-line__img" src="' + item.image + '" alt="" width="64" height="64" loading="lazy">' : '') +
      '</a>';
    const variant = item.product_has_only_default_variant ? '' : '<span class="cart-line__variant">' + (item.variant_title || '') + '</span>';
    return (
      '<li class="cart-line" data-cart-line data-line-key="' + item.key + '">' +
        media +
        '<div class="cart-line__info">' +
          '<a href="' + item.url + '" class="cart-line__title">' + item.product_title + '</a>' +
          variant +
          '<span class="cart-line__price">' + Theme.money(item.final_price) + '</span>' +
          '<div class="cart-line__controls">' +
            '<div class="qty" role="group">' +
              '<button type="button" class="qty__btn" data-cart-minus aria-label="Azalt">−</button>' +
              '<span class="qty__val" data-line-qty>' + item.quantity + '</span>' +
              '<button type="button" class="qty__btn" data-cart-plus aria-label="Arttır">+</button>' +
            '</div>' +
            '<span class="cart-line__total" data-line-total>' + Theme.money(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-line__remove" data-cart-remove aria-label="Kaldır">' +
          '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</li>'
    );
  };

  // Sepet çekmecesini cart.js verisiyle güncelle
  Theme.renderCart = function (cart) {
    const countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-total]').forEach((el) => {
      el.textContent = Theme.money(cart.total_price);
    });
    const sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = Theme.money(cart.total_price);

    const list = document.querySelector('[data-cart-items]');
    const footer = document.querySelector('[data-cart-footer]');
    if (list) {
      if (cart.item_count === 0) {
        list.innerHTML = '<p class="cart-drawer__empty">' + (window.cartStrings && window.cartStrings.empty || 'Sepetiniz boş.') + '</p>';
        if (footer) footer.hidden = true;
      } else {
        let html = '<ul class="cart-drawer__list">';
        cart.items.forEach((item) => { html += Theme.cartLineHTML(item); });
        html += '</ul>';
        list.innerHTML = html;
        if (footer) footer.hidden = false;
      }
    }
  };

  // AJAX sepete ekleme formları
  function initCartForms() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-cart-form]');
      if (!form) return;
      e.preventDefault();
      const button = form.querySelector('[data-add-button]');
      if (button) button.classList.add('is-loading');

      try {
        const formData = new FormData(form);
        const items = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) };
        await Theme.cart.add(items);
        const cart = await Theme.cart.get();
        Theme.renderCart(cart);
        // Sepet çekmecesini aç (ortak setDrawer ile: aria-expanded + focus tutarlı)
        const drawer = document.getElementById('CartDrawer');
        if (drawer) {
          const toggle = document.querySelector('[data-drawer-toggle="CartDrawer"]');
          setDrawer(drawer, toggle, true);
        }
      } catch (err) {
        console.error('Sepete eklenemedi', err);
      } finally {
        if (button) button.classList.remove('is-loading');
      }
    });
  }

  /* ----- Sepet çekmecesi: adet artır/azalt + kaldır (AJAX) ----- */
  function initCartDrawerEvents() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.addEventListener('click', async (e) => {
      const line = e.target.closest('[data-cart-line]');
      if (!line) return;
      const isMinus = e.target.closest('[data-cart-minus]');
      const isPlus = e.target.closest('[data-cart-plus]');
      const isRemove = e.target.closest('[data-cart-remove]');
      if (!isMinus && !isPlus && !isRemove) return;
      e.preventDefault();

      const key = line.getAttribute('data-line-key');
      const qtyEl = line.querySelector('[data-line-qty]');
      const current = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      let next = current;
      if (isMinus) next = current - 1;
      else if (isPlus) next = current + 1;
      else if (isRemove) next = 0;
      if (next < 0) next = 0;

      line.classList.add('is-loading');
      try {
        const cart = await Theme.cart.change({ id: key, quantity: next });
        Theme.renderCart(cart);
      } catch (err) {
        console.error('Sepet güncellenemedi', err);
        line.classList.remove('is-loading');
      }
    });
  }

  /* ----- Mega menü ----- */
  function initMegaMenu() {
    document.querySelectorAll('[data-megamenu]').forEach((menu) => {
      const trigger = menu.querySelector('[data-megamenu-trigger]');
      const panel = menu.querySelector('[data-megamenu-panel]');
      if (!trigger || !panel) return;

      const open = () => {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      };

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        panel.hidden ? open() : close();
      });

      // Sekmeler
      menu.querySelectorAll('[data-megamenu-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.getAttribute('data-megamenu-tab');
          menu.querySelectorAll('[data-megamenu-tab]').forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          menu.querySelectorAll('[data-megamenu-content]').forEach((c) => {
            c.classList.toggle('is-active', c.getAttribute('data-megamenu-content') === target);
          });
        });
      });

      document.addEventListener('click', (e) => {
        if (!menu.contains(e.target) && !panel.hidden) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !panel.hidden) {
          close();
          trigger.focus();
        }
      });
    });
  }

  /* ----- KVKK / çerez bandı ----- */
  function initCookieBanner() {
    const banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;
    try { if (localStorage.getItem('cookie-accepted') === '1') return; } catch (e) {}
    banner.hidden = false;
    const accept = banner.querySelector('[data-cookie-accept]');
    if (accept) {
      accept.addEventListener('click', () => {
        banner.hidden = true;
        try { localStorage.setItem('cookie-accepted', '1'); } catch (e) {}
      });
    }
  }

  /* ----- Başlatma ----- */
  function init() {
    initAnnouncementDismiss();
    initDrawers();
    initMegaMenu();
    initCartForms();
    initCartDrawerEvents();
    initCookieBanner();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Theme = Theme;
})();
